// import React from "react";
//
// export interface SliderProps {
//   /** an optional id for the input */
//   id?: string;
//   /** initial position as a single‐element array */
//   defaultValue?: number[];
//   /** controlled position as a single‐element array */
//   value?: number[];
//   /** min value (default 0) */
//   min?: number;
//   /** max value */
//   max?: number;
//   /** step size */
//   step?: number;
//   /** callback on change, gives [newValue] */
//   onValueChange?: (value: number[]) => void;
// }
//
// export const Slider: React.FC<SliderProps> = ({
//   id,
//   defaultValue,
//   value,
//   min = 0,
//   max,
//   step,
//   onValueChange,
// }) => {
//   // keep internal state so it renders
//   const [val, setVal] = React.useState<number>(
//     defaultValue?.[0] ?? value?.[0] ?? min
//   );
//
//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const num = parseFloat(e.target.value);
//     setVal(num);
//     onValueChange?.([num]);
//   };
//
//   return (
//     <input
//       id={id}
//       type="range"
//       min={min}
//       max={max}
//       step={step}
//       value={val}
//       onChange={handleChange}
//     />
//   );
// };
//
// /** These are just wrappers so your markup doesn’t break */
// export const SliderTrack: React.FC<{ children?: React.ReactNode }> = ({
//   children,
// }) => <div className="slider-track">{children}</div>;
// export const SliderRange: React.FC = () => <div className="slider-range" />;
// export const SliderThumb: React.FC = () => <div className="slider-thumb" />;

import React from "react";

export interface SliderProps {
  id?: string;
  value?: number[];
  defaultValue?: number[];
  min?: number;
  max?: number;
  step?: number;
  onValueChange?: (value: number[]) => void;
  className?: string;
  children?: React.ReactNode;
}

export const Slider: React.FC<SliderProps> = ({ id, value, defaultValue, min, max, step, onValueChange, className, children }) => {
  const val = value ? value[0] : defaultValue ? defaultValue[0] : min ?? 0;
  return (
    <input
      type="range"
      id={id}
      className={className}
      value={val}
      min={min}
      max={max}
      step={step}
      onChange={e => onValueChange && onValueChange([parseFloat(e.target.value)])}
    />
  );
};

export const SliderTrack: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...props }) => (
  <div className={className} {...props}>
    {children}
  </div>
);

export const SliderRange: React.FC = () => <div className="slider-range" />;
export const SliderThumb: React.FC = () => <div className="slider-thumb" />;